import Reflux from 'reflux';

const MessageCountsActions = Reflux.createActions({
  total: { asyncResult: true },
});

export default MessageCountsActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/messages/MessageCountsActions.jsx